export class ContactanosModel {
    informacion : string;
    estado : string;
    contacto : string;
    nombre : string;
    apellido1: string;
    apellido2: string;
    correo : string;
    telcel : string;
    telfijo : string;
    mensaje: string;

    constructor(){
        this.informacion ='';
        this.estado = '';
        this.contacto = '';
        this.nombre = '';
        this.apellido1 = '';
        this.apellido2 = '';
        this.correo = '';
        this.telcel = '';
        this.telfijo = '';
        this.mensaje = '';
    }
}